import { WithTooltip } from "../../components/WithTooltip";

// The confidence pill both lead boards render. `/leads` and `/leads/search`
// show the same row, so the colour bands and the hover behind them have to
// agree; the numbers and hover TEXT come from leadConfidence.ts beside it.
//
// The results list is denser than the inbox, so its cells run a point or so
// smaller. Required rather than defaulted: a caller that inherited the other
// board's size gets a badge subtly out of step with the text beside it, which
// is exactly what nobody notices in review.
export type ConfidenceBadgeSize = "compact" | "regular";

const BADGE_FONT_SIZE: Record<ConfidenceBadgeSize, number> = {
  compact: 10,
  regular: 11.5,
};
const DASH_FONT_SIZE: Record<ConfidenceBadgeSize, number> = {
  compact: 11,
  regular: 12.5,
};

export const ConfidenceBadge: React.FC<{
  confidence: number | null;
  size: ConfidenceBadgeSize;
  // Hover text explaining how the number was derived. Multi-line plain text, so
  // the operator can read why a row scored what it did without having to learn
  // the scoring formula by osmosis.
  tooltip?: string;
}> = ({ confidence, size, tooltip }) => {
  if (confidence == null) {
    return (
      <WithTooltip text={tooltip}>
        <span
          style={{
            color: "#aaa",
            fontSize: DASH_FONT_SIZE[size],
            cursor: tooltip ? "help" : undefined,
          }}
        >
          -
        </span>
      </WithTooltip>
    );
  }
  const colour =
    confidence >= 70 ? "#28a745" : confidence >= 40 ? "#ffc107" : "#6c757d";
  return (
    <WithTooltip text={tooltip}>
      <span
        style={{
          marginLeft: 4,
          padding: "0 4px",
          background: colour,
          color: "#fff",
          fontSize: BADGE_FONT_SIZE[size],
          borderRadius: 3,
          cursor: tooltip ? "help" : undefined,
        }}
      >
        {Math.round(confidence)}%
      </span>
    </WithTooltip>
  );
};
